import { useMemo } from "react";
import type { LiveInfo, StreamSource } from "@tih/shared";
import { StreamPlayer } from "../components/StreamPlayer";
import {
  isBroadcastLive,
  resolveShowingStream,
} from "../lib/live-display";

type Props = {
  initialInfo?: LiveInfo | null;
};

function resolveSource(ref: NonNullable<ReturnType<typeof resolveShowingStream>>): StreamSource | null {
  if (ref.source) return ref.source;
  if (ref.youtubeId) return { kind: "youtube", src: ref.youtubeId };
  return null;
}

export function LiveLandingPage({ initialInfo = null }: Props) {
  const info = initialInfo;
  const live = isBroadcastLive(info);
  const showing = useMemo(
    () => (info ? resolveShowingStream(info) : null),
    [info],
  );
  const source = showing ? resolveSource(showing) : null;

  return (
    <div className="live-landing-page">
      <div className="live-player-frame live-landing-player-frame">
        {source && showing ? (
          <StreamPlayer
            key={`${source.kind}:${source.src}`}
            source={source}
            live={live}
            autoPlay={live}
            title={showing.title}
          />
        ) : (
          <div className="live-empty">
            <div className="live-empty-inner">
              <p className="live-empty-title">Stream opens when we go live</p>
              <p className="live-empty-body">
                No player yet — when the overnight starts, video will appear here.
              </p>
            </div>
          </div>
        )}
      </div>
      {live && showing && (
        <div className="live-landing-caption">
          <span className="live-badge live-badge-on">
            <span className="lb-dot"></span>LIVE
          </span>
          <span>{showing.title}</span>
        </div>
      )}
    </div>
  );
}
